import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./index.css"
import GenAIHome from "./GenAIHome"
import GenAISidebar from "./GenAISidebar"
import { GenAIAnsweringContext } from './GenAIAnsweringContextProvider';
class index extends Component {
    static contextType = GenAIAnsweringContext;
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
        }
    }
    render() {
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (
            <div className="gen-ai-answering-screen-constraint">
                    <GenAISidebar customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
                <GenAIHome customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
            </div>)
        }
        else if (this.props.customWidth > 1000) {
            return (<div className="gen-ai-answering-container">
                <GenAISidebar customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
                <GenAIHome customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
            </div>)
        }
    }

}
export default withRouter(index);